import * as Yup from "yup";

const LoginOtpSchema = Yup.object().shape({
  otpDigits: Yup.string()
    .matches(/^[0-9]{4}$/, "Enter the 4 digits from the code in your email.")
    .required("Verification code is required."),
});

export default LoginOtpSchema;
